import { ReactNode } from "react";

import { IPaginator } from "common/types";

import TextInput from "client/common/components/inputs/TextInput";
import Pagination from "client/common/components/layouts/Pagination";

import styles from "../styles/PatientPickerChrome.module.less";

type PatientPickerChromeProps = {
  q: string;
  onQChange: (value: string) => void;
  paginator: IPaginator | null;
  onPageChange: (page: number) => void;
  showChrome: boolean;
  children: ReactNode;
};

const PatientPickerChrome = ({
  q,
  onQChange,
  paginator,
  onPageChange,
  showChrome,
  children,
}: PatientPickerChromeProps) => {
  const search = showChrome ? (
    <div className={styles.chrome}>
      <TextInput label="Search pets" value={q} onChange={onQChange} />
    </div>
  ) : null;
  const pager =
    showChrome && paginator ? (
      <div className={styles.pager}>
        <Pagination paginator={paginator} onPageChange={onPageChange} entityName="pet" />
      </div>
    ) : null;

  return (
    <>
      {search}
      {children}
      {pager}
    </>
  );
};

export default PatientPickerChrome;
